import { useEffect } from "react";

// Injects a Schema.org JSON-LD <script> tag into <head> for whichever page
// renders this, and removes it on unmount so navigating to a page without
// structured data (or with different data) never leaves a stale/wrong
// script behind. Multiple JsonLd instances can coexist on one page (e.g.
// LodgingBusiness + BreadcrumbList together) — each gets its own tag,
// keyed by a required `id` so they don't clobber each other.
const JsonLd = ({ id, schema }) => {
  useEffect(() => {
    if (!schema) return;

    const tagId = `jsonld-${id}`;
    let script = document.getElementById(tagId);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = tagId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      const el = document.getElementById(tagId);
      if (el) el.remove();
    };
  }, [id, schema]);

  return null;
};

export default JsonLd;
